import { AppError } from '@model/common';

export const getErrorCode = (error: AppError): string => {
  if (!error) return '';
  const { errorCode, errorText, response } = error;
  return `${errorCode || response?.status || errorText || ''}`;
};
